'use strict';

// Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.

module.exports = Array.isArray || function (arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/card-validator/src/lib/is-array.js
// module id = 1073
// module chunks = 1